import md5 from "md5";

/**
 * Obtém a URL do Gravatar com d=404 para retornar 404 quando não houver foto real
 * Isso permite que o Avatar component mostre o fallback (iniciais) quando não há foto no Gravatar
 */
export function getGravatarUrl(email: string | null | undefined, size: number = 200): string | null {
  if (!email) return null;
  
  const trimmedEmail = email.trim().toLowerCase();
  const hash = md5(trimmedEmail);
  // Usando d=404 para retornar 404 quando não houver foto real
  // O Avatar component mostrará o fallback automaticamente
  return `https://www.gravatar.com/avatar/${hash}?s=${size}&d=404&r=pg`;
}

